// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quill-editor[data-v-cde46e84]{height:200px}#add_question .modal-content[data-v-cde46e84]{box-shadow:0 8px 16px rgba(0,0,0,.5)}.agv-color[data-v-cde46e84]{color:#6bb545}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
